/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import X from '../icons/x.svg';
import type {GdprBanner} from './index';

export function template(this: GdprBanner) {
  const {hidden} = this.state;
  const mp23Brand = true;
  return (
    <div sel='.gdpr-banner-container' class={{hidden, 'mp23-brand': mp23Brand}}>
      {mp23Brand ? (
        <>
          <div sel='.gdpr-banner-content'>
            <div>
              Mixpanel uses cookies to run our site and improve its functionalities for a better browsing experience. To
              learn more about Mixpanel's use of cookies please review our{` `}
              <a attrs={{href: `https://mixpanel.com/legal/privacy-policy`}}>Privacy Policy</a>.
            </div>
            <div sel='.gdpr-banner-buttons'>
              <button sel='.button.gdpr-banner-accept-button' on={{click: this.helpers.onAccept}}>
                Accept
              </button>
              <button sel='.button.gdpr-banner-dismiss-button' on={{click: this.helpers.onDismiss}}>
                Decline
              </button>
            </div>
          </div>
          <button sel='.gdpr-banner-dismiss' on={{click: this.helpers.onDismiss}}>
            <img attrs={{src: X}} sel='.svg-icon' />
          </button>
        </>
      ) : (
        <>
          <div sel='.gdpr-banner-text'>
            {`Mixpanel uses cookies to make it easier for you to use our website; read more about our `}
            <a attrs={{href: `https://mixpanel.com/legal/privacy-policy`}}>cookie policy</a>
            {`. We will also collect personal information about you as described in our `}
            <a attrs={{href: `https://mixpanel.com/legal/privacy-policy`}}>privacy statement</a>
            {`. By using our services you agree to the use of cookies and to the collection of your personal information.`}
          </div>
          <button sel='.gdpr-banner-accept' on={{click: this.helpers.onAccept}}>
            Accept
          </button>
          <button sel='.gdpr-banner-accept' on={{click: this.helpers.onDismiss}}>
            Reject
          </button>
          <button sel='.gdpr-banner-dismiss' on={{click: this.helpers.onDismiss}}>
            <img attrs={{src: X}} sel='.svg-icon' />
          </button>
        </>
      )}
    </div>
  );
}
